import React, { Component } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import axios from 'axios';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';

export class FetchRemitter extends Component {
    state = {
        remitter: [],
        columns: [{
            dataField: 'remitterID',
            text: 'Remitter Id',
            hidden: true
        },
        {
            dataField: 'remitterName',
            text: 'Remitter Name',
            filter: textFilter(),
            sort: true
        }, {
            dataField: 'remitterCode',
            text: 'Remitter Code',
            filter: textFilter(),
            sort: true
        },
        {
            dataField: 'accessUrl',
            text: 'Access URL',
            sort: true,
        }
      ]
    }

    componentDidMount() {
        axios.get('api/remitter', { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
            .then(response => {
                console.log(response.data);
            this.setState({
                remitter: response.data
            });
        });
    }
    render() {
        const options = {

            sizePerPageList: [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
                }, {
                    text: 'All', value: this.state.remitter.length
            }],
            sizePerPage: 5,
            pageStartIndex: 1,
            paginationSize: 3,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',

        };
        return (
            <div className="card">
                <div>                
                    <h1 className="modal-header">Remitter</h1>                    
                   </div>
                <div style={{ marginTop: 20 }}>
                    <BootstrapTable
                        striped
                        hover
                        keyField='remitterID'
                        data={this.state.remitter}
                        columns={this.state.columns}
                        filter={filterFactory()}
                        pagination={paginationFactory(options)}
                        wrapperClasses="table-responsive"/>
                </div>
            </div>
        )
    }
}
